import {
  CommunityPost,
  CommunityPostsScopeEnum
} from '../../../../__generated__/graphql'

import CommunityLayout from './CommunityLayout'
import Posts from './Posts'
import ProfilePosts from './ProfilePosts'

export const PostsPageComponent: React.FC<{
  topicId?: string | string[]
  scope?: CommunityPostsScopeEnum
  ssrPosts?: CommunityPost[]
}> = ({ topicId, scope, ssrPosts }) => {
  return (
    <CommunityLayout topicId={topicId} scope={scope}>
      {scope ? <ProfilePosts /> : <Posts ssrPosts={ssrPosts} />}
    </CommunityLayout>
  )
}

export default PostsPageComponent
